import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formContainer: {
    maxHeight: "85vh",
    overflowX: "hidden",
    overflowY: "auto",
    scrollBehavior: "smooth",
    "-webkit-overflow-scrolling": "touch",
    padding: theme.spacing(0.5, 0.5),
    paddingBottom: theme.spacing(2),
    "&::-webkit-scrollbar": {
      width: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      background: "var(--total_row_boldbackground)",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    color: "var(--color-primary-main)",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    "&:first-child": {
      marginTop: 0,
    },
  },
  sectionCard: {
    padding: 0,
    backgroundColor: "transparent",
  },
  sectionHint: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    lineHeight: 1.5,
    marginTop: -4,
    marginBottom: theme.spacing(1),
  },
  field: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 13,
      backgroundColor: "var(--color-background-default)",
      "& fieldset": {
        borderColor: "var(--total_row_boldbackground)",
      },
      "&:hover fieldset": {
        borderColor: "var(--color-primary-main)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "var(--color-primary-main)",
        borderWidth: 1.5,
      },
    },
    "& .MuiInputLabel-outlined": {
      fontSize: 13,
      color: "var(--color-text-secondary)",
      transform: "translate(14px, 10px) scale(1)",
      "&.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 14px",
      color: "var(--color-text-primary)",
    },
    "& .MuiOutlinedInput-inputMultiline": {
      resize: "vertical",
    },
    "& .MuiInputAdornment-positionStart": {
      marginRight: 4,
      "& svg": {
        fontSize: 14,
        color: "var(--color-text-secondary)",
      },
    },
    "& .MuiFormHelperText-root": {
      fontSize: 11,
      marginLeft: 2,
      color: "var(--color-text-secondary)",
    },
    "& .MuiOutlinedInput-root.Mui-disabled": {
      backgroundColor: "var(--total_row_background)",
      "& fieldset": {
        borderColor: "var(--total_row_boldbackground)",
        borderStyle: "dashed",
      },
      "& .MuiOutlinedInput-input": {
        color: "var(--color-text-secondary)",
        WebkitTextFillColor: "var(--color-text-secondary)",
        cursor: "not-allowed",
      },
    },
    "& .MuiInputLabel-outlined.Mui-disabled": {
      color: "var(--color-text-secondary)",
      opacity: 0.7,
    },
  },
  checkboxControl: {
    "& .MuiTypography-body1": {
      fontSize: 13,
      fontWeight: 500,
      color: "var(--color-text-primary)",
    },
    "& .MuiCheckbox-root": {
      color: "var(--color-text-secondary)",
      "&.Mui-checked": {
        color: "var(--color-primary-main)",
      },
    },
  },
  checkboxRow: {
    margin: 0,
    "& .MuiTypography-body1": {
      fontSize: 13,
      fontWeight: 600,
      color: "var(--color-text-primary)",
    },
  },
  inlineNote: {
    fontSize: 11,
    color: "var(--color-text-secondary)",
    lineHeight: 1.4,
  },
  groupLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: "var(--color-text-secondary)",
    opacity: 0.8,
    pointerEvents: "none",
  },
  actionRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  },
  dialogFooter: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "0px 8px",
    gap: 8,
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      padding: "0px 4px",
      gap: 10,
    },
  },
  dialogFooterChecks: {
    marginRight: "auto",
    display: "flex",
    gap: 12,
    [theme.breakpoints.down("xs")]: {
      marginRight: 0,
      flex: "1 1 100%",
      flexWrap: "wrap",
      gap: 4,
    },
  },
  dialogFooterButtons: {
    display: "flex",
    gap: 8,
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 100%",
      "& > *": {
        flex: 1,
      },
    },
  },
  cancelBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    borderRadius: 8,
    padding: "6px 16px",
    color: "var(--color-text-secondary)",
  },
  submitBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    borderRadius: 8,
    padding: "6px 20px",
  },
  dropzone: {
    border: "2px dashed var(--total_row_boldbackground)",
    borderRadius: 10,
    padding: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: "var(--color-background-default)",
    minHeight: 72,
    "&:hover": {
      borderColor: "var(--color-primary-main)",
      backgroundColor: "var(--total_row_background)",
    },
  },
  dropzoneActive: {
    borderColor: "var(--color-primary-main)",
    backgroundColor: "var(--total_row_background)",
  },
  dropzoneIcon: {
    fontSize: 24,
    color: "var(--color-text-secondary)",
    marginBottom: 2,
  },
  dropzoneText: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    fontWeight: 500,
    textAlign: "center",
  },
  dropzoneBrowse: {
    color: "var(--color-primary-main)",
    fontWeight: 700,
    cursor: "pointer",
  },
  uploadHint: {
    marginTop: theme.spacing(1),
    fontSize: 11,
    color: "var(--color-text-secondary)",
    lineHeight: 1.5,
  },
  fileList: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  fileItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "5px 10px",
    borderRadius: 8,
    backgroundColor: "var(--total_row_background)",
    border: "1px solid var(--total_row_boldbackground)",
  },
  fileIcon: {
    fontSize: 16,
    color: "var(--color-text-secondary)",
  },
  fileName: {
    flex: 1,
    fontSize: 12,
    fontWeight: 600,
    color: "var(--color-text-primary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  fileSize: {
    fontSize: 11,
    color: "var(--color-text-secondary)",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
  fileRemoveBtn: {
    padding: 2,
    "& svg": { fontSize: 14, color: "var(--color-text-secondary)" },
    "&:hover svg": { color: "#ef4444" },
  },
  readOnlyBanner: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    backgroundColor: "var(--total_row_background)",
    border: "1px solid var(--total_row_boldbackground)",
    marginBottom: theme.spacing(2),
    fontSize: 12,
    fontWeight: 600,
    color: "var(--color-text-primary)",
  },
  errorText: {
    color: "#dc2626",
    fontSize: 12,
    fontWeight: 500,
    marginTop: 6,
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    fontSize: 12,
    fontWeight: 700,
    backgroundColor: "var(--color-primary-main)",
    color: "var(--color-primary-contrast)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    flexShrink: 0,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  avatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  optionContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.5, 0),
    width: "100%",
    color: "var(--color-text-primary)",
  },
}));

export default useStyles;
